var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "before-and-after-comparison",
          attrs: {
            visible: _vm.visible,
            title: _vm.$t("ChangeCharge.details"),
            width: "1300px",
            "close-on-click-modal": false,
            "show-close": false,
            top: "10vh",
            "append-to-body": _vm.appendToBody
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            open: _vm.showDialog
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "-30px", display: "flex" } },
            [
              _c(
                "div",
                { staticStyle: { "text-align": "right", width: "20%" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.showCharge,
                        callback: function($$v) {
                          _vm.showCharge = $$v
                        },
                        expression: "showCharge"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_HideUnmodifiedFees"))
                      )
                    ]
                  )
                ],
                1
              ),
              _vm.tips
                ? _c(
                    "div",
                    { staticStyle: { "text-align": "right", width: "70%" } },
                    [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_ChargeChangeTip")) +
                            " "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          ),
          _c(
            "el-tabs",
            {
              attrs: { "active-name": _vm.activeTabName },
              on: { "tab-click": _vm.handleClick }
            },
            [
              _c(
                "el-tab-pane",
                {
                  staticClass: "app-main-content",
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_Receivable"),
                    name: "receivable"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row",
                      staticStyle: { padding: "0 0 0 10px", height: "28px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: true,
                            "label-width": "60px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "13px",
                                "font-weight": "bold"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("ChangeCharge.modifyBefore"))
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row row-grid",
                      staticStyle: { height: "220px", padding: "0" },
                      attrs: { id: "vsPage1" }
                    },
                    [
                      _c("cargo-ag-grid", {
                        key: "chargeGrid1",
                        staticStyle: { height: "220px", width: "100%" },
                        attrs: {
                          "config-module": "202409",
                          "grid-params":
                            _vm.receivable.chargeBeforeGrid.gridParams,
                          "grid-options":
                            _vm.receivable.chargeBeforeGrid.gridOptions,
                          "column-defs": _vm.chargeBeforeGridColumnDefs,
                          "row-data": _vm.chargeBeforeRowDataReceivable,
                          "show-side-bar": true,
                          "auto-fit-content": false,
                          "min-height": "250"
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.receivable.chargeBeforeGrid,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.receivable.chargeBeforeGrid,
                              "gridParams",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end",
                        "padding-right": "10px",
                        "padding-top": "8px",
                        height: "30px",
                        "background-color": "#f5f7f7"
                      }
                    },
                    [
                      _c("span", {
                        staticStyle: { "font-size": "13px" },
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("ChangeCharge.estimateProfit")
                          )
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-right": "10px",
                            display: "inline-block",
                            "vertical-align": "middle"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            _vm._l(_vm.chargeOriginalProfit, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                { key: index },
                                [
                                  _c("change-charge-count-item-renderer", {
                                    attrs: { item: item }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row",
                      staticStyle: { padding: "0 0 0 10px", height: "28px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: true,
                            "label-width": "60px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "13px",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("ChangeCharge.modifyAfter")))]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row row-grid",
                      staticStyle: { height: "220px", padding: "0" }
                    },
                    [
                      _c("cargo-ag-grid", {
                        key: "chargeGrid2",
                        staticStyle: { height: "220px", width: "100%" },
                        attrs: {
                          "config-module": "202408",
                          "grid-params":
                            _vm.receivable.chargeAfterGrid.gridParams,
                          "grid-options":
                            _vm.receivable.chargeAfterGrid.gridOptions,
                          "column-defs": _vm.arChargeAfterGridColumnDefs,
                          "row-data": _vm.chargeAfterRowDataReceivable,
                          "auto-fit-content": false,
                          "min-height": "250"
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.receivable.chargeAfterGrid,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.receivable.chargeAfterGrid,
                              "gridParams",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end",
                        "padding-right": "10px",
                        "padding-top": "8px",
                        height: "30px",
                        "background-color": "#f5f7f7"
                      }
                    },
                    [
                      _c("span", {
                        staticStyle: { "font-size": "13px" },
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("ChangeCharge.estimateProfit")
                          )
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-right": "10px",
                            display: "inline-block",
                            "vertical-align": "middle"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _vm._l(_vm.chargeChangeProfit, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: index },
                                  [
                                    _c("change-charge-count-item-renderer", {
                                      attrs: { item: item }
                                    })
                                  ],
                                  1
                                )
                              }),
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.arTip) + " ")
                              ])
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  staticClass: "app-main-content",
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_Dues"),
                    name: "payable"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row",
                      staticStyle: { padding: "0 0 0 10px", height: "28px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: true,
                            "label-width": "60px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "13px",
                                "font-weight": "bold"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("ChangeCharge.modifyBefore"))
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row row-grid",
                      staticStyle: { height: "220px", padding: "0" }
                    },
                    [
                      _c("cargo-ag-grid", {
                        key: "chargeGrid1",
                        staticStyle: { height: "220px", width: "100%" },
                        attrs: {
                          "config-module": "202407",
                          "grid-params":
                            _vm.payable.chargeBeforeGrid.gridParams,
                          "grid-options":
                            _vm.payable.chargeBeforeGrid.gridOptions,
                          "column-defs": _vm.chargeBeforeGridColumnDefs,
                          "row-data": _vm.chargeBeforeRowDataPayable,
                          "auto-fit-content": false,
                          "min-height": "250"
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.payable.chargeBeforeGrid,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.payable.chargeBeforeGrid,
                              "gridParams",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end",
                        "padding-right": "10px",
                        "padding-top": "8px",
                        height: "30px",
                        "background-color": "#f5f7f7"
                      }
                    },
                    [
                      _c("span", {
                        staticStyle: { "font-size": "13px" },
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("ChangeCharge.estimateProfit")
                          )
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-right": "10px",
                            display: "inline-block",
                            "vertical-align": "middle"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            _vm._l(_vm.chargeOriginalProfit, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                { key: index },
                                [
                                  _c("change-charge-count-item-renderer", {
                                    attrs: { item: item }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row",
                      staticStyle: { padding: "0 0 0 10px", height: "28px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: true,
                            "label-width": "60px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "13px",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("ChangeCharge.modifyAfter")))]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "app-main-inner-row row-grid",
                      staticStyle: { height: "220px", padding: "0" }
                    },
                    [
                      _c("cargo-ag-grid", {
                        key: "chargeGrid2",
                        staticStyle: { height: "220px", width: "100%" },
                        attrs: {
                          "config-module": "202406",
                          "grid-params": _vm.payable.chargeAfterGrid.gridParams,
                          "grid-options":
                            _vm.payable.chargeAfterGrid.gridOptions,
                          "column-defs": _vm.apChargeAfterGridColumnDefs,
                          "row-data": _vm.chargeAfterRowDataPayable,
                          "auto-fit-content": false,
                          "min-height": "250"
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(
                              _vm.payable.chargeAfterGrid,
                              "gridParams",
                              $event
                            )
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(
                              _vm.payable.chargeAfterGrid,
                              "gridParams",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end",
                        "padding-right": "10px",
                        "padding-top": "8px",
                        height: "30px",
                        "background-color": "#f5f7f7"
                      }
                    },
                    [
                      _c("span", {
                        staticStyle: { "font-size": "13px" },
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("ChangeCharge.estimateProfit")
                          )
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-right": "10px",
                            display: "inline-block",
                            "vertical-align": "middle"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _vm._l(_vm.chargeChangeProfit, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: index },
                                  [
                                    _c("change-charge-count-item-renderer", {
                                      attrs: { item: item }
                                    })
                                  ],
                                  1
                                )
                              }),
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.apTip) + " ")
                              ])
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "2" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }